import { useRef, useState, useCallback } from "react"

const EXAMPLE_VIDEO =
  "https://dudpw00jtfdjq.cloudfront.net/videos/13/C77YdCOI4FMB/9d1W71HNLNnD.mp4"

const LBTN = { background: "#232325", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.07), -1px 0 3px rgba(0,0,0,0.4)" } as const
const RBTN = { background: "#232325", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.07),  1px 0 3px rgba(0,0,0,0.4)" } as const

export function VideoPhone({ src = EXAMPLE_VIDEO }: { src?: string }) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [unmuted, setUnmuted] = useState(false)

  const handleToggle = useCallback(() => {
    const video = videoRef.current
    if (!video) return

    if (unmuted) {
      video.muted = true
      setUnmuted(false)
    } else {
      video.currentTime = 0
      video.muted = false
      video.play()
      setUnmuted(true)
    }
  }, [unmuted])

  return (
    <div style={{ position: "relative", width: 280, margin: "0 auto" }}>
      {/* Left: mute */}
      <div style={{ position: "absolute", left: -5, top: 112, width: 5, height: 38, borderRadius: "3px 0 0 3px", ...LBTN }} />
      {/* Left: volume up */}
      <div style={{ position: "absolute", left: -5, top: 172, width: 5, height: 60, borderRadius: "3px 0 0 3px", ...LBTN }} />
      {/* Left: volume down */}
      <div style={{ position: "absolute", left: -5, top: 246, width: 5, height: 60, borderRadius: "3px 0 0 3px", ...LBTN }} />
      {/* Right: power */}
      <div style={{ position: "absolute", right: -5, top: 158, width: 5, height: 84, borderRadius: "0 3px 3px 0", ...RBTN }} />

      {/* Chassis */}
      <div style={{
        background: "linear-gradient(150deg, #252527 0%, #1C1C1E 50%, #141416 100%)",
        borderRadius: 56,
        padding: 10,
        boxShadow: [
          "inset 0 0 0 0.5px rgba(255,255,255,0.13)",
          "0 0 0 1px rgba(0,0,0,0.7)",
          "0 40px 100px rgba(0,0,0,0.55)",
          "0 10px 24px rgba(0,0,0,0.3)",
        ].join(", "),
      }}>
        {/* Screen */}
        <div style={{ background: "#000", borderRadius: 46, overflow: "hidden", boxShadow: "inset 0 0 0 0.5px rgba(255,255,255,0.05)" }}>
          {/* Dynamic island */}
          <div style={{ display: "flex", justifyContent: "center", paddingTop: 15, paddingBottom: 8 }}>
            <div style={{ width: 96, height: 23, background: "#1A1A1C", borderRadius: 100 }} />
          </div>
          {/* Video + play overlay */}
          <div
            onClick={handleToggle}
            style={{ position: "relative", aspectRatio: "9/16", cursor: "pointer" }}
          >
            <video
              ref={videoRef}
              src={src}
              autoPlay
              muted
              loop
              playsInline
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
            />
            {/* Play / unmute overlay */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "opacity 0.25s ease",
                opacity: unmuted ? 0 : 1,
                pointerEvents: unmuted ? "none" : "auto",
              }}
            >
              <div
                className="transition-transform hover:scale-110"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "rgba(0,0,0,0.45)",
                  backdropFilter: "blur(8px)",
                  WebkitBackdropFilter: "blur(8px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
                }}
              >
                <svg viewBox="0 0 24 24" fill="white" style={{ width: 28, height: 28, marginLeft: 3 }}>
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
          {/* Home indicator */}
          <div style={{ display: "flex", justifyContent: "center", paddingTop: 10, paddingBottom: 15 }}>
            <div style={{ width: 140, height: 5, background: "rgba(255,255,255,0.18)", borderRadius: 100 }} />
          </div>
        </div>
      </div>
    </div>
  )
}
